module.exports = __webpack_public_path__ + "img/app_default_img1.0d94db35.png";